import { render, staticRenderFns } from "./StyleIcon.vue?vue&type=template&id=1a2f6bc7&"
import script from "./StyleIcon.vue?vue&type=script&lang=js&"
export * from "./StyleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports